import React from 'react';
import { TipsMapType } from '..';

export const HeroGptTips: TipsMapType = {
  en: (
    <>
      Under the "Day" filter, the Hero summary is updated twice a week: <br />
      <br />
      1.Update every Monday: Summarize hero comments from 00:00 last Thursday to
      00:00 Monday <br />
      <br />
      2. Update every Thursday: Summarize hero comments from 00:00 Monday to
      00:00 Thursday
    </>
  ),
  zh: (
    <>
      “日”筛选器下，英雄总结内容每周更新两次：
      <br />
      <br />
      1. 每周一更新：总结上周四00:00-本周一00:00的英雄评论 <br />
      <br />
      2. 每周四更新：总结本周一00:00-本周四00:00的英雄评论
    </>
  ),
};
